import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Add } from '../../../../../assets/img/icons/common/Add.svg';
import { RootPortal } from '../../../../../components';
import { ModalAddMaterial } from './ModalAddMaterial';
import useHQPlayerStateContext from '../../../HistoryQueuePlayer/hooks/useHQPlayerStateContext';
import { useNotificationContext } from '../../../../../contexts/NotificationContext';
import { useCreateAdhocRec } from '../../../../../api/productionQueue';
import { usePermissions } from '../../../../../hooks/usePermissions';

export const AddMaterialButton = () => {
  const { historyState } = useHQPlayerStateContext();
  const { addNotification } = useNotificationContext();
  const { userType, permissions, restaurantUuid } = useSelector(state => state.login);
  const { CREATE } = usePermissions(userType, permissions);
  const show = !historyState && CREATE;

  const [createAdhoc, { isLoading }] = useCreateAdhocRec();

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {show && (
        <button className="text-red p-0" onClick={() => setModalOpen(true)}>
          <Add />
        </button>
      )}

      {modalOpen && (
        <RootPortal>
          <ModalAddMaterial
            loading={isLoading}
            onCancel={() => setModalOpen(false)}
            onConfirm={data => {
              createAdhoc({ restaurantUuid, data })
                .unwrap()
                .then(() => {
                  setModalOpen(false);
                  addNotification('success', 'Recommendation created successfully', 'Success', 3000);
                })
                .catch(e => {
                  addNotification('danger', e.message || 'Failed to create recommendation', 'Error', 3000);
                });
            }}
          />
        </RootPortal>
      )}
    </>
  );
};
